import Component from "@base/js/component";

export default class CountryLanding extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".country-landing";

  // Defines children that needs to be queried as part of this component
  static children = {
    // body: ".country-landing__body" // Queries a single element
    // items: [".country-landing__items"] // Queries a an array of elements
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // constructor() {
  //   super();
  // }

  // Will be called upon component instantiation
  afterInit() {
    /* eslint-disable no-console */
    console.log(`Component initialized`, this.element);
    /* eslint-enable no-console */
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
CountryLanding.init();
